import React, {
    Fragment,
    useCallback,
    useMemo,
    useRef,
    useState
} from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { UncontrolledTooltip } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { ConfirmationModal } from '../../../../../layout/Modal/ConfirmationModal';
import { uuid } from "../../../../../../helpers/uuid";
import { deleteAppointmentHoliday } from '../../../../../../api/appointmentHolidays/appointmentHolidays';

export function DeleteAppointmentHoliday(props) {
  const { appointmentHoliday, actionCallback } = props;
  const [ showDeleteModal, setShowDeleteModal ] = useState(false);
  const buttonRef = useRef(null);

  const actionDelete = useCallback(() => {
    deleteAppointmentHoliday({
      id: uuid(appointmentHoliday?.id),
    })
      .then(response => {
        if (response?.status === 204) {
          setShowDeleteModal(false);
          actionCallback();
        }
      });
  }, [ appointmentHoliday, actionCallback ]);

  const hasPermission = useMemo(() => {
    return true;
  }, [])

  if (!hasPermission) {
    return null;
  }

  return (
    <Fragment>
      <Link
        to="#"
        ref={buttonRef}
        className="cursor-pointer px-2 mx-2 link-icon-color delete-icon"
        onClick={e => {
          e.preventDefault();
          setShowDeleteModal(true);
        }}
      >
        <FontAwesomeIcon
          size="lg"
          className="cursor-pointer"
          icon={ faTrash }
        />
      </Link>
      <UncontrolledTooltip
        delay={ 0 }
        target={buttonRef}
        modifiers={
          {
            preventOverflow: {
              enabled: true,
              boundariesElement: 'body'
            }
          }
        }
      >
        <FormattedMessage id="button.delete"/>
      </UncontrolledTooltip>
      <ConfirmationModal
        showModal={ showDeleteModal }
        closeModal={ () => setShowDeleteModal(false) }
        confirmationYes={ actionDelete }
      />
    </Fragment>
  );
}
